// Guard against multiple script executions
if (!window.richTextVideoEmbedInitialized) {
  window.richTextVideoEmbedInitialized = true;
  
  console.log('Rich text video embed script initializing');

  // Function to extract video ID from YouTube URL
  function extractVideoId(url) {
    try {
      const urlObj = new URL(url);
      // Handle youtu.be links
      if (urlObj.hostname === 'youtu.be') {
        return urlObj.pathname.slice(1);
      }
      // Handle youtube.com links
      if (urlObj.hostname.includes('youtube.com')) {
        const videoId = urlObj.searchParams.get('v');
        if (videoId) return videoId;
        
        // Handle URLs with feature=shared parameter
        const sharedUrl = new URLSearchParams(urlObj.search).get('feature');
        if (sharedUrl === 'shared') {
          return urlObj.pathname.split('/').pop();
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  // Function to create video embed
  function createVideoEmbed(videoId) {
    return `
      <div class="video-wrapper">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/${videoId}"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    `;
  }

  // Function to process rich text content
  function processRichText() {
    const richTextElements = document.querySelectorAll('.rte');
    
    richTextElements.forEach(rte => {
      const youtubeLinks = rte.querySelectorAll('a[href*="youtu.be"], a[href*="youtube.com"]');
      
      youtubeLinks.forEach(link => {
        const videoId = extractVideoId(link.href);
        if (videoId) {
          console.log('Found video ID:', videoId);
          // Find the parent paragraph and replace it
          const parentP = link.closest('p');
          if (parentP) {
            parentP.outerHTML = createVideoEmbed(videoId);
          }
        }
      });
    });
  }

  // Process on load and after any Shopify section updates
  document.addEventListener('DOMContentLoaded', processRichText);
  document.addEventListener('shopify:section:load', processRichText);
}
